/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KemMessage } from '../models/KemMessage';
import type { KemMessagePartialExcluding_id_created_at_ } from '../models/KemMessagePartialExcluding_id_created_at_';
import type { KemMessageWithRelations } from '../models/KemMessageWithRelations';
import type { NewKemMessage } from '../models/NewKemMessage';
import type { SymptomHealthConditionWithRelations } from '../models/SymptomHealthConditionWithRelations';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class KemMessageControllerService {

    /**
     * @returns any Payload to initialize a kem chat
     * @throws ApiError
     */
    public static kemMessageControllerGetKemPayload(): CancelablePromise<{
        location?: string;
        user_id?: string;
        user_full_name?: string;
        date_of_birth?: string;
        gender?: string;
        exercise_duration_last_30_days?: number;
        coach_details?: Array<{
            coach_id?: string;
            coach_name?: string;
        }>;
        latest_bmi?: string;
        bmi_measurement_date?: string;
        latest_bp?: string;
        bp_measurement_date?: string;
        latest_blood_sugar?: string;
        blood_sugar_measurement_date?: string;
        latest_blood_sugar_meal_type?: string;
        latest_cholesterol?: string;
        cholesterol_measurement_date?: string;
        latest_weight?: string;
        weight_measurement_date?: string;
        latest_weight_goal?: string;
        weight_goal_measurement_date?: string;
        latest_height?: string;
        height_measurement_date?: string;
        latest_waist_circumference?: string;
        waist_circumference_measurement_date?: string;
        waist_circumference_goal?: string;
        latest_hbaic?: string;
        hbaic_measurement_date?: string;
        latest_total_psa?: string;
        latest_free_psa?: string;
        latest_psa_file_name?: string;
        psa_measurement_date?: string;
        latest_eye_examination?: string;
        eye_examination_measurement_date?: string;
        latest_foot_examination?: string;
        foot_examination_measurement_date?: string;
        latest_health_condition?: string;
        health_condition_measurement_date?: string;
        latest_procedure_surgeries?: string;
        procedure_surgeries_measurement_date?: string;
        lastest_prescription?: string;
        prescription_measurement_date?: string;
        pregnancy_status?: boolean;
        pregnancy_edd?: string;
        summarized_notes?: string;
        health_coach_name?: string;
        action_plan?: string;
        symptoms?: Array<SymptomHealthConditionWithRelations>;
        macro_goals?: Array<string>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-message/chat-payload',
        });
    }

    /**
     * @returns any Count of KemMessage records updated to seen
     * @throws ApiError
     */
    public static kemMessageControllerMarkAsSeen({
        requestBody,
    }: {
        requestBody?: {
            ids: Array<string>;
        },
    }): CancelablePromise<{
        count?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kem-message/mark-seen',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns KemMessageWithRelations Array of KemMessage by session key model instances
     * @throws ApiError
     */
    public static kemMessageControllerFindBySessionKey({
        sessionKey,
        filter,
        page,
    }: {
        sessionKey: string,
        filter?: any,
        page?: number,
    }): CancelablePromise<Array<KemMessageWithRelations>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-message/session-key/{sessionKey}',
            path: {
                'sessionKey': sessionKey,
            },
            query: {
                'filter': filter,
                'page': page,
            },
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static kemMessageControllerUpdateById({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: KemMessagePartialExcluding_id_created_at_,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/kem-message/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns KemMessageWithRelations KemMessage model instance
     * @throws ApiError
     */
    public static kemMessageControllerFindById({
        id,
        filter,
    }: {
        id: string,
        filter?: any,
    }): CancelablePromise<KemMessageWithRelations> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-message/{id}',
            path: {
                'id': id,
            },
            query: {
                'filter': filter,
            },
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static kemMessageControllerDeleteById({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/kem-message/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns KemMessage KemMessage model instance
     * @throws ApiError
     */
    public static kemMessageControllerCreate({
        requestBody,
    }: {
        requestBody?: NewKemMessage,
    }): CancelablePromise<KemMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/kem-message',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns KemMessageWithRelations Array of KemMessage model instances
     * @throws ApiError
     */
    public static kemMessageControllerFindAll({
        filter,
        page,
    }: {
        filter?: any,
        page?: number,
    }): CancelablePromise<Array<KemMessageWithRelations>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/kem-message',
            query: {
                'filter': filter,
                'page': page,
            },
        });
    }

}
